export default "__VITE_ASSET__Yf2EO5Mx__"